import { createSelector } from '@reduxjs/toolkit';
import { getWidgetDataAsyncData } from './getWidgetDataAsyncData';
export const getLatestWidgetData = createSelector(getWidgetDataAsyncData, widgetDataState => widgetDataState === null || widgetDataState === void 0 ? void 0 : widgetDataState.data);